import moment from 'moment';
import Constants from '../../../constants';
import * as StM from '../../store';

export interface IPublicUserStoreState {
    id: string;
    displayName: string;
    calendarSharingOption: string;
    imageId: number;
    skill: string;
    isAvailableForInvitation: boolean;
    hasPaymentInfo: boolean;
    paymentProfileStatus: string;
    isCreditCardValidating: boolean;
    invitedBy: string;
    isMinorFormSigned: boolean;
}

export interface IUserStoreState extends IPublicUserStoreState {
    userName: string;
    firstName: string;
    lastName: string;
    description: string;
    dateOfBirth: moment.Moment;
    disabled: boolean;
    gender: string;
    age:number;
    phone: string;
    email: string;
    discount: number;
    level: StM.IMembershipLevelStoreState;
    membershipLevels: StM.IMembershipLevelStoreState[];
    newsletterSubscribe: boolean;
    isSendTrainNotifications: boolean;
    isSendSpecialOffers: boolean;
    sendNotificationsPeriod: string;
    isPublic: boolean;
    isOneClickPayments: boolean;
    primaryCreditCardType: string;
    paymentProfileId: string;
    creditCardShort: string;
    imageId: number;
    lastAction: moment.Moment;
    registrationDate: moment.Moment;
    isWatchedTutorial: boolean;
    tierId: number;
    permissions: Array<StM.IPermissionStoreState>;
    creditsWallet: StM.ICreditsWalletStoreState;
    isAcceptedWaiver: boolean;
    outstandingBalance: number;
    emergencyContactPhoneNumber: string;
    emergencyContactFullName: string;
    emergencyContactRelationship: string;
    group: StM.IGroupStoreState;
    state: string;
    emailConfirmed: boolean;
    actualDetails: {
        discount: number,
        isSubscriptionDiscount: boolean,
        daysInAdvance: number,
        isSubscriptionDaysInAdvance: boolean
    }
}

export interface IAddedUserStoreState extends IPublicUserStoreState {
    paymentType: string;
    isAdded: boolean;
}
export interface ICoachStoreState extends IPublicUserStoreState {
    coachFeeTierId: number;
    coachFeeTier: StM.ICoachFeeTierStoreState;
    lastRecurrentAvailabilityApplicationDate: moment.Moment;
    description: string;
}

export class PublicUserStoreState implements IPublicUserStoreState {
    id: string;
    displayName: string;
    calendarSharingOption: string;
    skill: string;
    imageId: number;
    isAvailableForInvitation: boolean;
    hasPaymentInfo: boolean;
    paymentProfileStatus: string;
    isCreditCardValidating: boolean;
    invitedBy: string;
    isMinorFormSigned: boolean;

    constructor(dto?: any) {
        this.id = dto && dto.id ? dto.id : '';
        this.displayName = dto && dto.displayName ? dto.displayName : '';
        this.imageId = dto && dto.imageId ? dto.imageId : null;
        this.skill = dto && dto.skill ? dto.skill : '';
        this.isAvailableForInvitation = dto && dto.isAvailableForInvitation ? dto.isAvailableForInvitation : false;
        this.hasPaymentInfo = !!dto && !!dto.hasPaymentInfo;
        this.paymentProfileStatus = dto && dto.paymentProfileStatus ? dto.paymentProfileStatus : '';
        this.isCreditCardValidating = false;
        this.invitedBy = dto && dto.invitedBy ? dto.invitedBy : '';
        this.isMinorFormSigned = dto && dto.isMinorFormSigned;
    }
}

export class UserStoreState extends PublicUserStoreState implements IUserStoreState {
    userName: string;
    firstName: string;
    lastName: string;
    description: string;
    dateOfBirth: moment.Moment;
    disabled: boolean;
    gender: string;
    age:number;
    phone: string;
    email: string;
    discount: number;
    level: StM.IMembershipLevelStoreState;
    membershipLevels: StM.IMembershipLevelStoreState[];
    newsletterSubscribe: boolean;
    isSendTrainNotifications: boolean;
    isSendSpecialOffers: boolean;
    sendNotificationsPeriod: string;
    isPublic: boolean;
    isOneClickPayments: boolean;
    primaryCreditCardType: string;
    paymentProfileId: string;
    creditCardShort: string;
    lastAction: moment.Moment;
    registrationDate: moment.Moment;
    isAvailableForInvitation: boolean;
    hasPaymentInfo: boolean;
    isWatchedTutorial: boolean;
    tierId: number;
    permissions: Array<StM.IPermissionStoreState>;
    creditsWallet: StM.ICreditsWalletStoreState;
    isAcceptedWaiver: boolean;
    outstandingBalance: number;
    emergencyContactPhoneNumber: string;
    emergencyContactFullName: string;
    emergencyContactRelationship: string;
    group:StM.IGroupStoreState;
    state: string;
    emailConfirmed: boolean;
    actualDetails: {
        discount: number,
        isSubscriptionDiscount: boolean,
        daysInAdvance: number,
        isSubscriptionDaysInAdvance: boolean
    }
    
    constructor(dto?: any) {
        super(dto);
        this.id = dto && dto.id ? dto.id : '';
        this.userName = dto && dto.userName ? dto.userName : '';
        this.displayName = dto && dto.displayName ? dto.displayName : '';
        this.firstName = dto && dto.firstName ? dto.firstName : '';
        this.lastName = dto && dto.lastName ? dto.lastName : '';
        this.description = dto && dto.description ? dto.description : '';
        this.dateOfBirth = dto && dto.dateOfBirth ? moment(dto.dateOfBirth, Constants.DateTime.API_FORMAT) : null;
        this.disabled = dto && dto.disabled;
        this.gender = dto && dto.gender ? dto.gender : '';
        this.age = dto && dto.age ? dto.age : '';
        this.phone = dto && dto.phone ? dto.phone : '';
        this.email = dto && dto.email ? dto.email : '';
        this.discount = dto && dto.discount ? dto.discount : 0;
        this.level = dto && dto.level ? dto.level : null;
        this.membershipLevels = dto && dto.membershipLevels ? dto.membershipLevels : new Array<StM.IMembershipLevelStoreState>();
        this.newsletterSubscribe = dto && dto.newsletterSubscribe;
        this.isSendTrainNotifications = dto && dto.isSendTrainNotifications;
        this.isSendSpecialOffers = dto && dto.isSendSpecialOffers;
        this.sendNotificationsPeriod = dto && dto.sendNotificationsPeriod ? dto.sendNotificationsPeriod : '';
        this.isPublic = dto && dto.isPublic;
        this.isOneClickPayments = dto && dto.isOneClickPayments;
        this.primaryCreditCardType = dto && dto.primaryCreditCardType ? dto.primaryCreditCardType : '';
        this.paymentProfileId = dto && dto.paymentProfileId ? dto.paymentProfileId : '';
        this.creditCardShort = dto && dto.creditCardShort ? dto.creditCardShort : '';
        this.lastAction = dto && dto.lastAction ? moment(dto.lastAction, Constants.DateTime.API_FORMAT) : moment.min();
        this.registrationDate = dto && dto.registrationDate ? moment(dto.registrationDate, Constants.DateTime.API_FORMAT) : moment.min();
        this.isWatchedTutorial = dto && dto.isWatchedTutorial;
        this.tierId = dto && dto.tierId ? dto.tierId : '';
        this.permissions = dto && dto.permissions ? dto.permissions : new Array<StM.IPermissionStoreState>();
        this.creditsWallet = dto && dto.creditsWallet ? dto.creditsWallet : null;
        this.isAcceptedWaiver = dto && dto.isAcceptedWaiver;
        this.isAvailableForInvitation = dto && dto.isAvailableForInvitation ? dto.isAvailableForInvitation : false;
        this.outstandingBalance = dto && dto.outstandingBalance ? dto.outstandingBalance : 0;
        this.hasPaymentInfo = dto && dto.hasPaymentInfo;
        this.emergencyContactPhoneNumber = dto && dto.emergencyContactPhoneNumber ? dto.emergencyContactPhoneNumber : '';
        this.emergencyContactFullName = dto && dto.emergencyContactFullName ? dto.emergencyContactFullName : '';
        this.emergencyContactRelationship = dto && dto.emergencyContactRelationship ? dto.emergencyContactRelationship : '';
        this.group = dto && dto.group ? dto.group : null
        this.state = dto && dto.state ? dto.state : '';
        this.emailConfirmed = dto && (dto.isEmailConfirmed || dto.emailConfirmed);
        this.actualDetails = dto?.actualDetails ?? null;
    }
}

export class CoachStoreState extends PublicUserStoreState implements ICoachStoreState {
    coachFeeTierId: number;
    coachFeeTier: StM.ICoachFeeTierStoreState;
    lastRecurrentAvailabilityApplicationDate: moment.Moment;
    description: string;

    constructor(dto?: any) {
        super(dto);
        this.coachFeeTier = dto && dto.coachFeeTier ? dto.coachFeeTier : null;
        this.coachFeeTierId = dto && dto.coachFeeTierId ? dto.coachFeeTierId : null;
        this.description = dto && dto.description ? dto.description : '';
        this.lastRecurrentAvailabilityApplicationDate = dto && dto.lastRecurrentAvailabilityApplicationDate ? moment(dto.lastRecurrentAvailabilityApplicationDate, Constants.DateTime.API_FORMAT) : null;
    }
}

export class AddedUserStoreState extends PublicUserStoreState implements IAddedUserStoreState {
    paymentType: string;
    isAdded: boolean = true;

    constructor(dto?: any) {
        super(dto);
        this.paymentType = dto && dto.paymentType ? dto.paymentType : null;
    }
}

export class IUserManagableStoreState {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    newsletterSubscribe: boolean;
    doSendTrainNotifications: boolean;
    doSendSpecialOffers: boolean;
    sendNotificationsPeriod: string;
    aliasedTimeZone: IAliasedTimeZoneDto;
    timeZoneId: number;
    skill: string;
    age: number;
    gender: string;
    phone: string;
    isAvailableForInvitation: boolean;
    hasPaymentInfo: boolean;
    dateOfBirth: moment.Moment;
    emergencyContactPhoneNumber: string;
    emergencyContactFullName: string;
    emergencyContactRelationship: string;
    archived: boolean;
}

export class UserManagableStoreState implements IUserManagableStoreState {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    newsletterSubscribe: boolean;
    doSendTrainNotifications: boolean;
    doSendSpecialOffers: boolean;
    sendNotificationsPeriod: string;
    aliasedTimeZone: IAliasedTimeZoneDto;
    timeZoneId: number;
    skill: string;
    age: number;
    gender: string;
    phone: string;
    isAvailableForInvitation: boolean;
    hasPaymentInfo: boolean;
    dateOfBirth: moment.Moment;
    emergencyContactPhoneNumber: string;
    emergencyContactFullName: string;
    emergencyContactRelationship: string;
    archived: boolean;

    constructor(dto?: any) {
        this.id = dto && dto.id ? dto.id : '';
        this.email = dto && dto.email ? dto.email : '';
        this.firstName = dto && dto.firstName ? dto.firstName : '';
        this.lastName = dto && dto.lastName ? dto.lastName : '';
        this.newsletterSubscribe = !!(dto && dto.newsletterSubscribe);
        this.doSendTrainNotifications = !!dto && !!dto.doSendTrainNotifications;
        this.doSendSpecialOffers = !!dto && !!dto.doSendSpecialOffers;
        this.sendNotificationsPeriod = dto && dto.sendNotificationsPeriod ? dto.sendNotificationsPeriod : '';
        this.aliasedTimeZone = dto && dto.aliasedTimeZone ? dto.aliasedTimeZone : null;
        this.timeZoneId = dto && dto.timeZoneId ? dto.timeZoneId : 0;
        this.skill = dto && dto.skill ? dto.skill : '';
        this.age = dto && dto.age ? dto.age : 0;
        this.gender = dto && dto.gender ? dto.gender : '';
        this.phone = dto && dto.phone ? dto.phone : '';
        this.isAvailableForInvitation = !!dto && !!dto.isAvailableForInvitation ? dto.isAvailableForInvitation : false;
        this.hasPaymentInfo = !!dto && !!dto.hasPaymentInfo;
        this.dateOfBirth = dto && dto.dateOfBirth ? moment(dto.dateOfBirth, Constants.DateTime.API_FORMAT) : moment.min();
        this.emergencyContactPhoneNumber = dto && dto.emergencyContactPhoneNumber ? dto.emergencyContactPhoneNumber : '';
        this.emergencyContactFullName = dto && dto.emergencyContactFullName ? dto.emergencyContactFullName : '';
        this.emergencyContactRelationship = dto && dto.emergencyContactRelationship ? dto.emergencyContactRelationship : '';
        this.archived = dto && dto.archived ? dto.archived : false;
    }
}

export interface IUserEditableStoreState extends IUserStoreState {
    email: string;
    age: number;
    lastRecurrentAvailabilityApplicationDate: moment.Moment;
    coachFeeTierId: number;
    coachFeeTier: StM.ICoachFeeTierStoreState;
}

export class UserEditableStoreState extends UserStoreState implements IUserEditableStoreState {
    email: string;
    age: number;
    coachFeeTierId: number;
    
    coachFeeTier: StM.ICoachFeeTierStoreState;
    lastRecurrentAvailabilityApplicationDate: moment.Moment;

    constructor(dto?: any) {
        super(dto);
        this.coachFeeTier = dto && dto.coachFeeTier ? dto.coachFeeTier : null;
        this.coachFeeTierId = dto && dto.coachFeeTierId ? dto.coachFeeTierId : null;
        this.email = dto && dto.email ? dto.email : '';
        this.age = dto && dto.age ? dto.age : 0;
        this.lastRecurrentAvailabilityApplicationDate = dto && dto.lastRecurrentAvailabilityApplicationDate ? moment(dto.lastRecurrentAvailabilityApplicationDate, Constants.DateTime.API_FORMAT) : null;
    }
}